// Path: src\Components\Tournament\TournamentDetails\TournamentDetails.jsx
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { AppBar, Tabs, Tab, Box } from "@mui/material";
import BaseHome from "../../Home/BaseHome";
import tournamentlist from "../../../images/tournamentlist.png";
import Diamond from "../../../images/Diamond.png";
import Qualification from "../../Popup/Qualification";
import RoundImage from "../../../images/roundimages.png";
import kills from "../../../images/kills.png";
import userimg from "../../../images/user.png";
import ranksimg from "../../../images/ranks.png";
import prizeimg from "../../../images/points.png";
import premiumicon from "../../../images/premium.png";
import trophyimg from "../../../images/trophyimg.png";
import sharewithfriendicon from "../../../images/sharewithfriendicon.png";
import { useEffect } from "react";
import { formatDate, formatTime, shareLink } from "../../../Utilities/helper";
import {
  getTournamentDetails,
  getTableImage,
  getRules,
  getTournamentRoundDetails,
  getTournamentPlayerDetails,
} from "../../../api/tournament.api";
import { toastError, toastSuccess } from "../../../Utilities/toast";
import WinningBreakup from "../../Popup/WinningPopup";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { base_apis, url } from "../../../config/url";
import { t } from "i18next";
import { RWebShare } from "react-web-share";
import ListLoader from '../../Common/ListLoader';

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && <Box className="tab-content">{children}</Box>}
    </div>
  );
};
const TournamentDetails = () => {
  const navigate = useNavigate();
  const [value, setValue] = useState(0); // Control the selected tab state
  const [isInputVisible, setIsInputVisible] = useState(false);
  const [isQualification, setQualification] = useState(false);
  const [qualification, setQualificationData] = useState(null);
  const [isDetailOpenRound1, setIsDetailOpenRound1] = useState(null);
  // State to manage whether the detail div is shown or not
  const [isDetailOpen, setIsDetailOpen] = useState(true);
  const [eventID, setEventID] = useState(null);
  const [tournamentDetails, setTournamentDetails] = useState(null);
  const [tournamentRoundDetails, setTournamentRoundDetails] = useState(null);
  const [tournamentPlayerDetails, setTournamentPlayerDetails] = useState(null);
  const [tournamentCaptainDetails, setTournamentCaptainDetails] =
    useState(null);
  const [isPricePointPoolModel, setPricePointPool] = useState(false);
  const [winningbrarkupContest, setWinningBrarkupContest] = useState(null);
  const [tableImg, setTableImage] = useState(null);
  const [rules, setRules] = useState([
    "KRAFTON will endeavor to eradicate misconducts described in the Rules of Conduct to ensure that the users can enjoy playing the game.",
  ]);
  const [totalPlayers, setTotalPlayers] = useState(0);
  const [joinedPlayers, setJoinedPlayers] = useState(0);
  const [userId, setuserId] = useState(null);
  const percentage = (joinedPlayers / totalPlayers) * 100; // Calculate percentage
  const [loading, setLoading] = useState(false)

  const getFeatureImg = (data) => {
    return data && data.default
      ? `${base_apis?.imageUrl}${data.default}`
      : tournamentlist;
  };
  const getCurrencyImg = (data, currencyType) => {
    const result = data.find((item) => item?.[currencyType]?.img?.default);
    return result
      ? `${base_apis?.imageUrl}${result.inCurrency.img.default}`
      : Diamond;
  };
  const getTableImg = (imgURL) => {
    return imgURL ? `${base_apis?.imageUrl}${imgURL}` : Diamond;
  };
  // Function to toggle the detail section
  const toggleDetail = () => {
    setIsDetailOpen(!isDetailOpen);
  };
  // Function to toggle the detail section
  const toggleDetailRound1 = (rounDataToOpen) => {
    if (rounDataToOpen !== isDetailOpenRound1) {
      setIsDetailOpenRound1(rounDataToOpen);
    } else {
      setIsDetailOpenRound1(null);
    }
  };
  const handleQualificationClick = (data) => {
    console.log(data);
    setQualification(true);
    setQualificationData(data);
  };
  const toggleInputVisibility = () => {
    setIsInputVisible(!isInputVisible);
  };
  const handleChange = (event, newValue) => {
    if (newValue == 0) {
      let userId = JSON?.parse(localStorage.getItem("profile"))?.user_id;
      setuserId(userId);
      let eventId =
        window.location.href.split("/")[
          window.location.href.split("/").length - 1
        ];
      setEventID(eventId);
      if (eventId) {
        fetchTournamentDetails(eventId, userId);
      } else {
        toastSuccess("Tournament Id Not Found..");
      }
    } else if (newValue == 1) {
      let eventId =
        window.location.href.split("/")[
          window.location.href.split("/").length - 1
        ];
      setEventID(eventId);
      if (eventId) {
        fetchTableImage(eventId, userId);
      } else {
        toastSuccess("Tournament Id Not Found..");
      }
    } else if (newValue == 2) {
      let eventId =
        window.location.href.split("/")[
          window.location.href.split("/").length - 1
        ];
      setEventID(eventId);
      if (eventId) {
        fetchPlayerDetails(eventId, userId);
      } else {
        toastSuccess("Tournament Players Details Not Found..");
      }
    } else if (newValue == 3) {
      let eventId =
        window.location.href.split("/")[
          window.location.href.split("/").length - 1
        ];
      setEventID(eventId);
      if (eventId) {
        fetchRules(eventId, userId);
      } else {
        toastSuccess("Tournament Rulels Not Found..");
      }
    }

    setValue(newValue); // Update the selected tab when changed
  };
  useEffect(() => {
    let userId = JSON?.parse(localStorage.getItem("profile"))?.user_id;
    setuserId(userId);
    let eventId =
      window.location.href.split("/")[
        window.location.href.split("/").length - 1
      ];
    setEventID(eventId);
    if (eventId) {
      fetchTournamentDetails(eventId, userId);
      fetchTournamentRoundDetails(eventId, userId);
    } else {
      toastSuccess("Tournament Id Not Found..");
    }
  }, []);
  const fetchTournamentDetails = async (eventId, userId) => {
    setLoading(true)
    try {
      if (eventId && userId) {
        let payload = {
          filter: {
            tournamentType: "gamerji",
            user: userId,
          },
        };
        const res = await getTournamentDetails(eventId, payload);
        if (res?.success && res?.item) {
          setLoading(false)
          setTournamentDetails(res?.item);
          setJoinedPlayers(res?.item?.totalJoinedPlayers);
          setTotalPlayers(res?.item?.totalPlayers);
        } else {
          setLoading(false)
          setTournamentDetails(null);
        }
      } else {
        setLoading(false)
        console.log("user_id not found in localstorage");
      }
    } catch (error) {}
  };
  const fetchTournamentRoundDetails = async (eventId, userId) => {
    try {
      if (eventId && userId) {
        let payload = {
          event: eventId,
          user: userId,
        };
        const res = await getTournamentRoundDetails(eventId, payload);
        if (res?.success && res?.contests) {
          console.log(res?.contests)
          setTournamentRoundDetails(res?.contests);
          setIsDetailOpenRound1(
            res?.contests?.[res?.contests?.length - 1 || 0]?._id
          );
        } else {
          setTournamentRoundDetails(null);
        }
      } else {
        console.log("user_id not found in localstorage");
      }
    } catch (error) {
      console.log(error);
    }
  };
  const fetchTableImage = async (eventId, userId) => {
    try {
      if (eventId && userId) {
        let payload = {
          // filter: {
          //   tournamentType: "gamerji",
          //   user: userId
          // }
        };
        const res = await getTableImage(eventId, payload);
        if (res?.success && res?.item) {
          setTableImage(getTableImg(res.item.eventTableImage.default));
        } else {
          setTournamentDetails(null);
        }
      } else {
        console.log("user_id not found in localstorage");
      }
    } catch (error) {}
  };
  const fetchRules = async (eventId, userId) => {
    try {
      if (eventId && userId) {
        let payload = {};
        const res = await getRules(eventId, payload);
        if (res?.success && res?.item) {
          setRules(res.item.rules);
        } else {
          setTournamentDetails(null);
        }
      } else {
        console.log("user_id not found in localstorage");
      }
    } catch (error) {}
  };
  const fetchPlayerDetails = async (eventId, userId) => {
    try {
      if (eventId && userId) {
        let payload = {
          skip: 0,
          limit: 10000,
          event: eventId,
          user: userId,
          sortBy: "createdAt",
          sort: "desc",
        };
        const res = await getTournamentPlayerDetails(eventId, payload);
        if (res?.success && res.list) {
          setTournamentPlayerDetails(res.list);
          setTournamentCaptainDetails(res.captainData);
        } else {
          setTournamentPlayerDetails(null);
        }
      } else {
        console.log("user_id not found in localstorage");
      }
    } catch (error) {}
  };
  const showWinningBreakup = (tournamentId) => {
    if (tournamentId) {
      setWinningBrarkupContest(tournamentId);
      setPricePointPool(true);
    } else {
      setWinningBrarkupContest(null);
      setPricePointPool(false);
    }
  };

  let getRoundStatus = (contest, index) => {
    if (contest?.contest?.isFinalRound) {
      return undefined;
    }

    if (contest?.contest?.status != "completed") {
      return 'Pending';
    }
    if (contest?.rank > 0 && (parseInt(contest?.contest?.winnerCount || 0) >= parseInt(contest?.rank || 0)) && !contest?.isHacking) {
      return 'Qualified';
    } else {
      return "notQualified";
    }
  };

  let getRoundStatusDesc = (contest, index) => {
    if (contest?.contest?.isFinalRound) {
      return undefined;
    }
    if (getRoundStatus(contest, index) == "Pending") {
      return "pending";
    }
    if (getRoundStatus(contest, index) == "Qualified") {
      return "qualified for next round";
    }
    return "sorry ! you are not qualified";
  };

  return (
    <BaseHome title="tournament details" onBackClick={() => navigate(-1)}>
      <div className="commontabs commontabs-four custome-tabing-section">
        <div className="commontabs-innerwrap">
          <Tabs
            value={value}
            onChange={handleChange}
            className="tabs-container custome-tabing-wrap"
          >
            <Tab
              label="details"
              className="tab custome-tab"
              style={{ textTransform: "lowercase" }}
            />
            <Tab
              label="table"
              className="tab custome-tab"
              style={{ textTransform: "lowercase" }}
            />
            <Tab
              label="players"
              className="tab custome-tab"
              style={{ textTransform: "lowercase" }}
            />
            <Tab
              label="rules"
              className="tab custome-tab"
              style={{ textTransform: "lowercase" }}
            />
          </Tabs>
        </div>

        {/* Render content based on selected tab */}
        <TabPanel className="tournament-tab-panel" value={value} index={0}>
          {loading && <div className='w-100 d-flex justify-content-center no-record-found-center'> <ListLoader /></div>}
          {tournamentDetails && tournamentDetails?._id === eventID && (
            <>
              <div className="tournamentdetails-card-wraper" style={{marginTop:"5rem"}}>
                {/* Card */}
                <div className="container tournament-card--wrap mt-4">
                  <div className="tournament-card detail-title-padding mb-4">
                    <div className="card-body d-flex flex-column justify-content-between">
                      <div className="tournamentdetail-card-title text-truncate">
                        {tournamentDetails?.title?.length > 25 ? (
                          <marquee> {tournamentDetails?.title}</marquee>
                        ) : (
                          tournamentDetails?.title
                        )}
                        {/* {tournamentDetails.title} */}
                      </div>

                      <hr></hr>
                      <div className="row">
                        <div className="col-3 pe-0 tournament-img">
                          <div className="tournament-img--wapr">
                            <img
                              src={`${getFeatureImg(
                                tournamentDetails?.featuredImage
                              )}`}
                              alt="game"
                              className="rounded"
                            />
                            <span className="tournament-img--data">
                              {tournamentDetails?.gameTypeAry?.name}
                            </span>
                          </div>
                        </div>

                        <div className="col-9 ps-1">
                          <div className="tournament-card-detail">
                            <div className="row">
                              {/* First row (date, round, ID) */}
                              <div className="col-12 tournament-card-box--wrap mb-2">
                                <div className="row">
                                  <div className="col-4 tournament-card-box">
                                    <div className="detail-item">
                                      <div className="tournament-detail-label letter-spacing">
                                        {moment(
                                          tournamentDetails?.startDate
                                        ).format("DD/MM/YYYY")}
                                      </div>
                                      <div className="tournament-detail-value">
                                        {t("tournament_list.date")}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-4 tournament-card-box">
                                    <div className="detail-item">
                                      <div className="tournament-detail-label">
                                        {tournamentDetails?.rounds || 0}
                                      </div>
                                      <div className="tournament-detail-value">
                                        {t("tournament_list.round")}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-4 tournament-card-box">
                                    <div className="detail-item">
                                      <div className="tournament-detail-label">
                                        {tournamentDetails?.shortCode}
                                      </div>
                                      <div className="tournament-detail-value">
                                        {t("tournament_list.id")}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* Second row (map, perspective, kill points) */}
                              <div className="col-12 tournament-card-box--wrap">
                                <div className="row">
                                  {tournamentDetails?.titles?.[0]?.isSelection &&
                                    tournamentDetails?.titles?.[0]?.name &&
                                    tournamentDetails?.titles?.[0]?.value && (
                                      <div className="col-4 tournament-card-box">
                                        <div className="detail-item">
                                          <div className="tournament-detail-label">
                                            {/* {tournamentDetails?.titles?.[0]?.value
                                              .length > 7 ? (
                                              <marquee>
                                                {
                                                  tournamentDetails?.titles?.[0]
                                                    ?.value
                                                }
                                              </marquee>
                                            ) : (
                                              tournamentDetails?.titles?.[0]
                                                ?.value
                                            )} */}
                                            {tournamentDetails?.titles?.[0]?.value}
                                          </div>
                                          <div className="tournament-detail-value">
                                            {/* {tournamentDetails?.titles?.[0]?.name
                                              .length > 7 ? (
                                              <marquee>
                                                {
                                                  tournamentDetails?.titles?.[0]
                                                    ?.name
                                                }
                                              </marquee>
                                            ) : (
                                              tournamentDetails?.titles?.[0]?.name
                                            )} */}
                                            {tournamentDetails?.titles?.[0]?.name}
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  {tournamentDetails?.titles?.[1]?.isSelection &&
                                    tournamentDetails?.titles?.[1]?.name &&
                                    tournamentDetails?.titles?.[1]?.value && (
                                      <div className="col-4 tournament-card-box">
                                        <div className="detail-item">
                                          <div className="tournament-detail-label">
                                            {/* {tournamentDetails?.titles?.[1]?.value
                                              .length > 7 ? (
                                              <marquee>
                                                {
                                                  tournamentDetails?.titles?.[1]
                                                    ?.value
                                                }
                                              </marquee>
                                            ) : (
                                              tournamentDetails?.titles?.[1]
                                                ?.value
                                            )} */}
                                            {tournamentDetails?.titles?.[1]?.value}
                                          </div>
                                          <div className="tournament-detail-value">
                                            {/* {tournamentDetails?.titles?.[1]?.name
                                              .length > 7 ? (
                                              <marquee>
                                                {
                                                  tournamentDetails?.titles?.[1]
                                                    ?.name
                                                }
                                              </marquee>
                                            ) : (
                                              tournamentDetails?.titles?.[1]?.name
                                            )} */}
                                            {tournamentDetails?.titles?.[1]?.name}
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                    {tournamentDetails?.killPoints &&
                                  <div className="col-4 tournament-card-box">
                                    <div className="detail-item">
                                      <div className="tournament-detail-label">
                                        {tournamentDetails.killPoints || 0}
                                      </div>
                                      <div className="tournament-detail-value">
                                        {t("tournament_list.kills_point")}
                                      </div>
                                    </div>
                                  </div>}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="mt-2">
                        <div className="tournament-details-winnings">
                          <div className="d-flex justify-content-between">
                            <p className="prize-info">
                              {t("tournament_list.prize_pool")}
                              <span className="tournament-prizepool">
                                {tournamentDetails?.prizePoolType === "amount"
                                  ? tournamentDetails?.prizePool
                                  : tournamentDetails?.rewardDisplayText}
                                {tournamentDetails?.prizePoolType &&
                                  tournamentDetails?.prizePoolType ==
                                    "amount" && (
                                    <img
                                      className="currency-icon"
                                      src={`${url.IMAGE_URL}${tournamentDetails?.currency[0]?.outCurrency?.img?.default}`}
                                      alt=""
                                    />
                                  )}
                              </span>
                            </p>

                            <p className="join-info">
                              winners{" "}
                              <span className="tournament-prizepool">
                                {tournamentDetails?.totalWinners !== undefined
                                  ? tournamentDetails?.totalWinners
                                  : 0}
                                {tournamentDetails?.prizePoolType &&
                                  tournamentDetails?.prizePoolType ==
                                    "amount" && (
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      className="tournament-arrow-icon"
                                      viewBox="0 0 20 20"
                                      onClick={() =>
                                        showWinningBreakup(tournamentDetails?._id)
                                      } // Add
                                      style={{ cursor: "pointer" }} // Optional: Add
                                    >
                                      <path d="M5.83288 8.33326L9.99956 12.4999L14.16622 8.33326" />
                                    </svg>
                                  )}
                              </span>
                            </p>

                            <p className="join-using" style={{color:"#d5d6d9"}}>
                              join using{" "}
                              {tournamentDetails?.entryFee > 0 ? (
                                <span className="tournament-prizepool">
                                  {tournamentDetails?.entryFee || 0}
                                  <img
                                    className="currency-icon"
                                    src={`${url.IMAGE_URL}${tournamentDetails?.currency[0]?.inCurrency?.img?.default}`}
                                    alt=""
                                  />
                                </span>
                              ) : (
                                <span className="tournament-prizepool">Free</span>
                              )}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="d-flex justify-content-between align-items-center mt-2">
                        {/* Progress Bar */}
                        <div
                          className="progress"
                          style={{ height: "6px", width: "100%" }}
                        >
                          <div
                            className="progress-bar"
                            role="progressbar"
                            style={{
                              width: `${percentage}%`, // Dynamically set width
                              backgroundColor: "#9F6693", // Change color if 100%
                            }}
                            aria-valuenow={joinedPlayers}
                            aria-valuemin="0"
                            aria-valuemax={totalPlayers}
                          ></div>
                        </div>
                      </div>

                      <p className="progressbar-text mt-2 mb-0">
                        <div>{joinedPlayers} {joinedPlayers > 1 ? t('tournament_list.players_joined') : t('tournament_list.player_joined')}</div>
                        <div>{totalPlayers}</div>
                      </p>
                    </div>
                  </div>
                </div>
                {/* rounds */}
                <div className="tournamentdetail-rounds-title mb-2">
                  tournament rounds
                </div>
                {/* Round Details */}
                {tournamentRoundDetails && tournamentRoundDetails.length > 0 && (
                  <>
                    {tournamentRoundDetails.map((round, index) => {
                      return (
                        <>
                          <>
                            <div className="tournamentround-detail-container mt-0">
                              <div className="container tournament-card--wrap">
                                <div className="tournament-card detail-title-padding mb-4">
                                  <div className="card-body d-flex flex-column justify-content-between"  onClick={() => {
                                            toggleDetailRound1(round._id);
                                          }}>
                                    <div className="tournamentdetail-box-round-title">
                                      <div className="col-5 tournamentdetailroundtitle">
                                        {round?.contest?.title?.length > 25 ? (
                                          <marquee>
                                            {" "}
                                            {round?.contest?.title}
                                          </marquee>
                                        ) : (
                                          round?.contest?.title
                                        )}
                                        {/* {round?.contest?.title} */}
                                      </div>
                                      <div class="col-7 qualified-text">
                                        <div className="">
                                          {getRoundStatusDesc(
                                            round,
                                            index
                                          )}
                                        </div>
                                        <span
                                          className="svg-container"
                                         
                                        >
                                          {isDetailOpenRound1 === round._id ? (
                                            // SVG when details are open
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="11"
                                              height="6"
                                              viewBox="0 0 11 6"
                                              fill="none"
                                            >
                                              <path
                                                d="M1.708 1.14648L5.49768 4.93592L9.29159 1.14648"
                                                stroke="white"
                                                strokeWidth="1.66667"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                              />
                                            </svg>
                                          ) : (
                                            // SVG when details are closed
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="6"
                                              height="11"
                                              viewBox="0 0 6 11"
                                              fill="none"
                                            >
                                              <path
                                                d="M1.14648 1.70837L4.93592 5.49781L1.14648 9.29171"
                                                stroke="white"
                                                strokeWidth="1.66667"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                              />
                                            </svg>
                                          )}
                                        </span>
                                      </div>
                                    </div>
                                    {isDetailOpenRound1 === round._id && (
                                      <>
                                        <hr style={{margin:"0.5rem 0"}}></hr>
                                        <div className="row">
                                          <div className="col-12">
                                            <div className="tournament-card-detail">
                                              <div className="row">
                                                {/* First row (date, round, ID) */}
                                                <div className="col-12 tournament-card-box--wrap">
                                                  <div className="row">
                                                    <div className="col-3 tournament-card-box">
                                                      <div className="detail-item">
                                                        <div className="tournament-detail-label">
                                                          {/* {round?.contest?.date
                                                            .length > 7 ? (
                                                            <marquee>
                                                              {moment(
                                                                round?.contest
                                                                  ?.date
                                                              ).format(
                                                                "DD/MM/YY"
                                                              )}
                                                            </marquee>
                                                          ) : (
                                                            moment(
                                                              round?.contest?.date
                                                            ).format("DD/MM/YY")
                                                          )} */}
                                                          {moment(
                                                            round?.contest?.date
                                                          ).format("DD/MM/YYYY")}
                                                        </div>
                                                        <div className="tournament-detail-value letter-spacing">
                                                          date
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div className="col-3 tournament-card-box">
                                                      <div className="detail-item">
                                                        <div className="tournament-detail-label">
                                                          {moment(
                                                            round?.contest?.time
                                                          ).format("hh:mm a")}
                                                        </div>
                                                        <div className="tournament-detail-value">
                                                          time
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div
                                                      className="col-3 tournament-card-box"
                                                      onClick={() => {
                                                        handleQualificationClick(
                                                          round?.contest
                                                        );
                                                      }}
                                                    >
                                                      <div className="detail-item">
                                                        <div className="tournament-detail-label">
                                                          <span className="tournament-prizepool">
                                                            {
                                                              round?.contest
                                                                ?.winnerCount
                                                            }
                                                            <svg
                                                              xmlns="http://www.w3.org/2000/svg"
                                                              class="tournament-arrow-icon"
                                                              viewBox="0 0 20 20"
                                                            >
                                                              <path d="M5.83288 8.33326L9.99956 12.4999L14.16622 8.33326" />
                                                            </svg>
                                                          </span>
                                                        </div>
                                                        <div className="tournament-detail-value">
                                                          qualification
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div className="col-3 tournament-card-box">
                                                      <div className="detail-item">
                                                        <div className="tournament-detail-label">
                                                          {
                                                            round?.contest
                                                              ?.shortCode
                                                          }
                                                        </div>
                                                        <div className="tournament-detail-value">
                                                          ID
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                      <div className="d-flex justify-content-between align-items-center mt-2">
                                        {/* Progress Bar */}
                                        <div
                                          className="progress"
                                          style={{ height: "6px", width: "100%" }}
                                        >
                                          <div
                                            className="progress-bar"
                                            role="progressbar"
                                            style={{
                                              width: `${(round?.contest?.totalJoinedPlayers / round?.contest?.totalPlayers) * 100}%`, // Dynamically set width
                                              backgroundColor: "#9F6693", // Change color if 100%
                                            }}
                                            aria-valuenow={round?.contest?.totalJoinedPlayers}
                                            aria-valuemin="0"
                                            aria-valuemax={round?.contest?.totalPlayers}
                                          ></div>
                                        </div>
                                      </div>

                                      <p className="progressbar-text mt-2 mb-0">
                                        <div>{round?.contest?.totalJoinedPlayers} {round?.contest?.totalJoinedPlayers > 1 ? 'players' : 'player'} joined</div>
                                        <div>{round?.contest?.totalPlayers}</div>
                                      </p>
                                      <div className="d-flex justify-content-between align-items-center tournament-copied-detail--wrap mt-1">
                                        <div className="tournament-copied-detaild" style={{display:"block"}}>
                                        <span className="tournament-details-roomid-value">
                                            {" "}
                                            {round?.contest?.roomId || "-"}{" "}{" "}
                                          </span>{" "}
                                          {round?.contest?.roomId &&
                                            <span className="tournament-detail-svg">
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="9"
                                                height="10"
                                                viewBox="0 0 9 10"
                                                fill="none"
                                              >
                                                <g clip-path="url(#clip0_2738_2557)">
                                                  <path
                                                    d="M8.8965 1.965L7.0515 0.1C6.9885 0.035 6.8985 0 6.8085 0H3.114C2.412 0 1.845 0.575 1.845 1.28V1.86H1.269C0.567 1.86 0 2.435 0 3.14V8.72C0 9.425 0.5715 10 1.269 10H5.886C6.588 10 7.155 9.425 7.155 8.72V8.14H7.731C8.433 8.14 9 7.565 9 6.86V2.21C9 2.12 8.964 2.03 8.8965 1.965ZM7.155 1.19L7.821 1.86H7.155V1.19ZM6.462 8.72C6.462 9.04 6.2055 9.3 5.886 9.3H1.269C0.9495 9.3 0.693 9.04 0.693 8.72V3.14C0.693 2.82 0.9495 2.56 1.269 2.56H1.845V6.86C1.845 7.565 2.4165 8.14 3.114 8.14H6.462V8.72ZM7.731 7.44H3.114C2.7945 7.44 2.538 7.18 2.538 6.86V1.28C2.538 0.96 2.7945 0.7 3.114 0.7H6.462V2.21C6.462 2.405 6.615 2.56 6.8085 2.56H8.307V6.86C8.307 7.18 8.0505 7.44 7.731 7.44Z"
                                                    fill="white"
                                                  />
                                                  <path
                                                    d="M6.80834 5.57996H4.04084C3.85184 5.57996 3.69434 5.73496 3.69434 5.92996C3.69434 6.12496 3.84734 6.27996 4.04084 6.27996H6.80834C6.99734 6.27996 7.15484 6.12496 7.15484 5.92996C7.15484 5.73496 7.00184 5.57996 6.80834 5.57996Z"
                                                    fill="white"
                                                  />
                                                  <path
                                                    d="M6.80834 3.71997H4.04084C3.85184 3.71997 3.69434 3.87497 3.69434 4.06997C3.69434 4.26497 3.84734 4.41997 4.04084 4.41997H6.80834C6.99734 4.41997 7.15484 4.26497 7.15484 4.06997C7.15484 3.87497 7.00184 3.71997 6.80834 3.71997Z"
                                                    fill="white"
                                                  />
                                                </g>
                                                <defs>
                                                  <clipPath id="clip0_2738_2557">
                                                    <rect width="9" height="10" fill="white" />
                                                  </clipPath>
                                                </defs>
                                              </svg>
                                            </span>
                                          }
                                          <div className="tournament-details-roomid-lable">
                                            room id
                                          </div>{" "}
                                         
                                        </div>
                                        <div className="tournament-copied-detaild" style={{display:"block"}}>
                                      <div className="d-flex justify-content-end align-items-center">
                                      <span className="tournament-details-roomid-value me-1">
                                            {" "}
                                            {round?.contest?.roomPassword || "-"}{" "}{" "}
                                          </span>{" "}
                                          {round?.contest?.roomPassword &&
                                            <span className="tournament-detail-svg">
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="9"
                                                height="10"
                                                viewBox="0 0 9 10"
                                                fill="none"
                                              >
                                                <g clip-path="url(#clip0_2738_2557)">
                                                  <path
                                                    d="M8.8965 1.965L7.0515 0.1C6.9885 0.035 6.8985 0 6.8085 0H3.114C2.412 0 1.845 0.575 1.845 1.28V1.86H1.269C0.567 1.86 0 2.435 0 3.14V8.72C0 9.425 0.5715 10 1.269 10H5.886C6.588 10 7.155 9.425 7.155 8.72V8.14H7.731C8.433 8.14 9 7.565 9 6.86V2.21C9 2.12 8.964 2.03 8.8965 1.965ZM7.155 1.19L7.821 1.86H7.155V1.19ZM6.462 8.72C6.462 9.04 6.2055 9.3 5.886 9.3H1.269C0.9495 9.3 0.693 9.04 0.693 8.72V3.14C0.693 2.82 0.9495 2.56 1.269 2.56H1.845V6.86C1.845 7.565 2.4165 8.14 3.114 8.14H6.462V8.72ZM7.731 7.44H3.114C2.7945 7.44 2.538 7.18 2.538 6.86V1.28C2.538 0.96 2.7945 0.7 3.114 0.7H6.462V2.21C6.462 2.405 6.615 2.56 6.8085 2.56H8.307V6.86C8.307 7.18 8.0505 7.44 7.731 7.44Z"
                                                    fill="white"
                                                  />
                                                  <path
                                                    d="M6.80834 5.57996H4.04084C3.85184 5.57996 3.69434 5.73496 3.69434 5.92996C3.69434 6.12496 3.84734 6.27996 4.04084 6.27996H6.80834C6.99734 6.27996 7.15484 6.12496 7.15484 5.92996C7.15484 5.73496 7.00184 5.57996 6.80834 5.57996Z"
                                                    fill="white"
                                                  />
                                                  <path
                                                    d="M6.80834 3.71997H4.04084C3.85184 3.71997 3.69434 3.87497 3.69434 4.06997C3.69434 4.26497 3.84734 4.41997 4.04084 4.41997H6.80834C6.99734 4.41997 7.15484 4.26497 7.15484 4.06997C7.15484 3.87497 7.00184 3.71997 6.80834 3.71997Z"
                                                    fill="white"
                                                  />
                                                </g>
                                                <defs>
                                                  <clipPath id="clip0_2738_2557">
                                                    <rect width="9" height="10" fill="white" />
                                                  </clipPath>
                                                </defs>
                                              </svg>
                                            </span>
                                          }
                                      </div>
                                          <div className="tournament-details-roomid-lable">
                                            password
                                          </div>{" "}
                                    
                                        </div>
                                      </div>
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* Captain Details */}
                          {(isDetailOpenRound1 === round._id) && (
                            <div className="tournament-detail-playertable mb-5">
                              <div className="player-header">
                                <div className="player-header-item justify-content-center align-items-center">
                                  <img className="players-table-img" src={userimg} style={{margin:"0"}}></img>
                                  {t('tournament_list.username')}
                                </div>
                                <div className="player-header-item justify-content-center align-items-center">
                                  <img className="players-table-img" src={kills} style={{margin:"0"}}></img> {t('tournament_list.kills')}
                                </div>
                                <div className="player-header-item justify-content-center align-items-center">
                                  <img className="players-table-img" src={ranksimg} style={{margin:"0"}}></img>  {t('tournament_list.rank')}
                                </div>
                                <div className="player-header-item justify-content-center align-items-center">
                                  <img className="players-table-img" src={prizeimg} style={{margin:"0"}}></img>{" "}
                                  {t('tournament_list.points')}
                                </div>
                              </div>
                              <div className="player-row">
                                <div className="player-row-item justify-content-center">{round?.user?.gamerjiName || "N/A"} 
                                  <span>
                                    {round?.user?.isPremium &&
                                      <img
                                            className="players-table-img"
                                            src={premiumicon}
                                            alt="Premium Icon"
                                          />
                                    }
                                    </span>
                            </div>
                                <div className="player-row-item">{round?.kills || "-"}</div>
                                <div className="player-row-item">{round?.rank || "-"}</div>
                                <div className="player-row-item">{round?.totalPoint || "-"}</div>
                              </div>
                            </div>
                          )}
                        </>
                      </>
                    )})}
                  </>
                )}
              </div>
              <RWebShare
                data={shareLink(tournamentDetails?.shortCode)}
                sites={["facebook", "twitter", "whatsapp", "linkedin", "copy"]}
                onClick={() => {
                  console.log("shared successfully!");
                }}
              >
                <button className="d-flex justify-content-center submit-button mt-4 mb-4">
                  <span>
                    <img
                      className="sharewithfriendscontesttournament-img"
                      src={sharewithfriendicon}
                      alt=""
                    ></img>
                  </span>
                  <div className="sharewithfriendscontesttournament-text">
                    {" "}
                    {t("tournament_list.share_with_friends")}
                  </div>
                </button>
              </RWebShare>
            </>
          )}
        </TabPanel>
        <TabPanel className="tournament-tab-panel" value={value} index={1}>
          <div className="tournament-players">
            {tableImg &&
              <img src={tableImg} alt="roundsimage"></img>
            }
          </div>
        </TabPanel>
        <TabPanel className="tournament-tab-panel" value={value} index={2}>
          {tournamentPlayerDetails && (
            <div className="tournament-players-tab">
              <div className="tournament-players-tab-wrap position-fixed">
                <div className="player-header">
                  <div className="player-header-item">
                    <img
                      className="players-table-img"
                      src={userimg}
                      alt="User Icon"
                    />
                    <span> {t("tournament_list.username")}</span>
                  </div>
                  <div className="player-header-item">
                    <img
                      className="players-table-img"
                      src={kills}
                      alt="Kills Icon"
                    />
                    <span>{t("tournament_list.kills")}</span>
                  </div>
                  <div className="player-header-item">
                    <img
                      className="players-table-img"
                      src={ranksimg}
                      alt="Ranks Icon"
                    />
                    <span>{t("tournament_list.rank")}</span>
                  </div>
                  <div className="player-header-item">
                    <img
                      className="players-table-img"
                      src={prizeimg}
                      alt="Points Icon"
                    />
                    <span> {t("tournament_list.points")}</span>
                  </div>
                </div>
              </div>
              <div className="tournament-detail-playertable">
                {tournamentCaptainDetails && tournamentCaptainDetails?._id && (
                  <div className="player-row">
                    <div className="player-row-item">
                      <span>{tournamentCaptainDetails?.user?.gamerjiName}</span>
                      {tournamentCaptainDetails?.isPremium && (
                        <img
                          className="players-table-img"
                          src={premiumicon}
                          alt="Premium Icon"
                        />
                      )}
                    </div>
                    <div className="player-row-item">
                      <span>{tournamentCaptainDetails?.kills || "-"}</span>
                      {tournamentCaptainDetails?.totalAmount > 0 && !tournamentCaptainDetails?.isHacking && (
                        <div className="player-win-info">
                          <img className="players-table-img-won" src={trophyimg} alt="Trophy Icon" />
                          <span>won</span> <span>{tournamentCaptainDetails?.totalAmount}</span>
                          {/* <img className="players-table-img-won" src={Diamond} alt="Gem Icon" /> */}
                          
                          <img className="players-table-img-won" src={`${url.IMAGE_URL}${tournamentDetails?.currency[0]?.outCurrency?.img?.default}`} alt="Gem Icon" />
                        </div>
                      )}
                    </div>
                    <div className="player-row-item">
                      <span>{tournamentCaptainDetails?.rank || "-"}</span>
                    </div>
                    <div className="player-row-item">
                      <span>{tournamentCaptainDetails?.points || "-"}</span>
                    </div>
                  </div>
                )}
                {tournamentPlayerDetails &&
                  tournamentPlayerDetails?.length > 0 &&
                  tournamentPlayerDetails.map((player) => {
                    return <>
                      <div className="player-row" style={{cursor:"pointer"}} 
                      // onClick={() => navigate('/user-profile/' + player?.user?._id)}
                       >
                        <div className="player-row-item">
                          <span>
                          {player?.user?.gamerjiName &&
                              player.user.gamerjiName.length > 15 ? (
                                <marquee>{player.user.gamerjiName}</marquee>
                              ) : (
                                player?.user?.gamerjiName
                              )}

                              {/* {player?.user?.gamerjiName} */}
                          </span>
                          {player?.isPremium &&
                            <img
                              className="players-table-img"
                              src={premiumicon}
                              alt="Premium Icon"
                            />
                          }
                        </div>
                        <div className="player-row-item">
                          <span>{player?.kills || "-"}</span>
                          {/* {player?.totalAmount > 0 &&
                            <div className="player-win-info">
                              <img className="players-table-img-won" src={trophyimg} alt="Trophy Icon" />
                              <span>won</span> <span>{player?.totalAmount}</span>
                              <img className="players-table-img-won" src={Diamond} alt="Gem Icon" />
                            </div>
                          } */}

                        </div>
                        <div className="player-row-item">
                          <span>{player?.rank || "-"}</span>
                        </div>
                        <div className="player-row-item">
                          <span>{player?.points || "-"}</span>
                        </div>
                      </div>
                    </>
                  })}
              </div>
            </div>
          )}
        </TabPanel>
        <TabPanel className="tournament-tab-panel" value={value} index={3}>
        <div className="private-scrim-game-rules private-scrims-manage-rules private-scrims-manage-rules-height-update tournament_rules" >

<div className="rules-list private-contest-manage-height " dangerouslySetInnerHTML={{ __html: rules }} />
{loading && <div className={'w-100 d-flex justify-content-center no-record-found-center'}> <ListLoader /></div>}
</div>
        </TabPanel>
      </div>
      {isQualification && (
        <Qualification
          isOpen={isQualification}
          title="Qualification"
          onClose={() => setQualification(false)}
          qualification={qualification}
        />
      )}

      <div>
        {isPricePointPoolModel && winningbrarkupContest != null && (
          <WinningBreakup
            isOpen={isPricePointPoolModel}
            contestId={winningbrarkupContest}
            contestData={tournamentDetails}
            popupType={"tournament"}
            title="Winning Breakup"
            onClose={() => setPricePointPool(false)}
          />
        )}
      </div>
    </BaseHome>
  );
};

export default TournamentDetails;
